<script setup>
import { computed, ref } from 'vue'

import { useAuditText } from './audit-text.js'
import { locationRows } from './run-observer.js'

const props = defineProps({
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
})

const { tr } = useAuditText()
const playerLocation = computed(() => props.branch.state?.positions?.[props.pack.player_id])
const rows = computed(() => locationRows(props.pack, props.branch.state).map((place) => ({
  ...place,
  people: place.people.map((person) => person.name).join(tr('separator')) || tr('empty'),
})))
// 点选一个地点，在芯片下方显示它的描述；再点一次收起。
const selectedId = ref('')
const selected = computed(() => rows.value.find((place) => place.id === selectedId.value) ?? null)

function toggle(placeId) {
  selectedId.value = selectedId.value === placeId ? '' : placeId
}
</script>

<template>
  <div class="au-positions">
    <ul class="au-chips" :aria-label="tr('timeline.positions')" data-testid="observer-positions">
      <li v-for="place in rows" :key="place.id">
        <button
          type="button"
          class="au-place"
          :class="{ 'is-player': place.id === playerLocation }"
          :aria-pressed="place.id === selectedId ? 'true' : 'false'"
          :data-testid="`observer-place-${place.id}`"
          @click="toggle(place.id)"
        >
          <strong>{{ place.name }}</strong><span>{{ tr('timeline.placePeople', { people: place.people }) }}</span>
        </button>
      </li>
    </ul>
    <p v-if="selected" class="au-body" data-testid="observer-place-description">
      <strong>{{ selected.name }}</strong> · {{ selected.description || tr('empty') }}
    </p>
  </div>
</template>
